import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { alert_error, alert_success } from '../../../AppContext';
import { Cookies } from '../../../index.js';
import Post_content from '../../../community/content/Blog_posts.jsx';
import Language_i18 from '../../../js/useNationalLanguage.jsx';

const MyComponent = () => {
    const { i18n, lang } = Language_i18();
    const translate = {
        en: {
            add_insta_account: "Add cross instagram account",
            select_account_insta: "Select account instagram for tasks",
            add_threads_account: "Please add cross threads account",
            select_account_threads: "Select account instagram for tasks",
            add_cross_account: "Please add cross Instagram account",
            convert_points_button: "Convert points to Coins",
            current_points: "Current points are",
            first_go_here: "First, go here →",
            select_follow_account: "To select the account you use to Follow →",
            cross_follow_insta: "Cross Follow insta to earn points",
            active: "Active →",
            like_insta: "Like insta to earn points",
            cross_follow_threads: "Cross Follow threads to earn points",
            like_threads: "Like threads to earn points",
            convert_points_link: "Convert points to Coins",
            loading_list: "Loading list"
        },
        vi: {
            add_insta_account: "Thêm tài khoản chéo insta",
            select_account_insta: "Chọn Tài khoản insta làm nhiệm vụ",
            add_threads_account: "Thêm tài khoản chéo threads",
            select_account_threads: "Chọn Tài khoản threads làm nhiệm vụ",
            add_cross_account: "Vui lòng thêm tài khoản chéo instagram",
            convert_points_button: "Chuyển điểm sang Coins",
            current_points: "Số điểm hiện tại là",
            first_go_here: "Đầu tiên bạn vô đây nhé →",
            select_follow_account: "Để chọn tài khoản bạn dùng để Follow →",
            cross_follow_insta: "Follow Chéo insta nhận điểm",
            active: "Active →",
            like_insta: "Thả Tim insta nhận điểm",
            cross_follow_threads: "Follow Chéo threads nhận điểm",
            like_threads: "Thả Tim threads nhận điểm",
            convert_points_link: "Đổi điểm sang Coins",
            loading_list: "Đang tải danh sách"
        }
    };
    const [point_vipig, set_point_vipig] = useState('');
    const checktk = () => {
        const myCookieValue = Cookies.get('apikey');
        axios.post('https://hust.media/insta/profile.php', {
            key: myCookieValue,
            chedo: 'kiemtradangnhap'
        })
            .then(response => {
                asdasdkas(response.data);
            })
            .catch(error => console.log(error));
    };
    const asdasdkas = (info) => {
        console.log(info.status);
        if (info.status == 1) {
            alert_success(info.message);
            set_point_vipig(info.sodiem);
            console.log(info.sodiem);
        } else {
            if (info.status == 3) {
                alert_success(translate[lang]?.add_cross_account);
                // history.push('/themcauhinh');
            } else if (info.status == 4) {
                alert_error(info.message);
                // history.push('/naptien');
            }
        }
    };
    useEffect(() => {
        checktk();
    }, []);
    return (
        <div>
            <div id="hientruyen"></div>
            <div className="max-w-2xl px-1 py-4 mx-auto rounded-lg shadow-xl">
                {point_vipig === '' ?
                    (<>
                        <div className="container-fluid">
                            <div className="row bg-pink-200">
                                <p className="text-center text-white">
                                    <div className="text-center spinner-border" role="status"></div>
                                    <br />
                                    {translate[lang]?.loading_list}
                                </p>
                            </div>
                        </div>
                    </>) :
                    (<>
                        <div className="row fixrow">
                            <div className="text-center">
                                <Link
                                    type="button"
                                    className="mx-2 btn btn-primary"
                                    to="/reactapp/exchangepoints/insta?webappmode=showadview"
                                >
                                    {translate[lang]?.convert_points_button}
                                </Link>
                                <div>
                                    {translate[lang]?.current_points} {point_vipig}
                                </div>
                            </div>

                            <div className="mt-0">
                                <div className="grid grid-cols-2 gap-1">
                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/insta/themcauhinh?mode=insta" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://cdn-icons-png.flaticon.com/512/992/992651.png"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        {translate[lang]?.add_insta_account}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.first_go_here}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/insta/listcauhinh?mode=insta" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPPeznG6LK16yZ70cv9p-KcIITtk6ASnWOUA&usqp=CAU"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        {translate[lang]?.select_account_insta}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.select_follow_account}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>

                            <div className="mt-0">
                                <div className="grid grid-cols-2 gap-1">
                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/insta/themcauhinh?mode=threads" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://cdn-icons-png.flaticon.com/512/992/992651.png"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        {translate[lang]?.add_threads_account}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.first_go_here}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/insta/listcauhinh?mode=threads" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPPeznG6LK16yZ70cv9p-KcIITtk6ASnWOUA&usqp=CAU"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        {translate[lang]?.select_account_threads}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.select_follow_account}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            
                            <div className="mt-0">
                                <div className="grid grid-cols-2 gap-1">
                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/insta/subcheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://hust.media/img/icon/follow2.svg"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        {translate[lang]?.cross_follow_insta}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.active}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/insta/timcheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://hust.media/img/icon/timins.png"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        {translate[lang]?.like_insta}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.active}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/threads/subcheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://hust.media/img/icon/follow2.svg"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        {translate[lang]?.cross_follow_threads}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.active}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/sunflower/threads/timcheo?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">
                                                        <img
                                                            src="https://hust.media/img/icon/timins.png"
                                                            className="h-7 w-7 cananh"
                                                            alt="icon"
                                                        />
                                                        {translate[lang]?.like_threads}
                                                    </p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.active}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>

                            <div className="mt-0">
                                <div className="grid grid-cols-2 gap-1">
                                    <Link style={{ textDecoration: 'none' }} to="/reactapp/exchangepoints/insta?webappmode=showadview" className="max-w-7xl mx-2 py-2 mb-2">
                                        <div className="relative group">
                                            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                                            <div className="relative px-3 py-3 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
                                                <div className="space-y-2">
                                                    <p className="text-lg text-slate-1000">{translate[lang]?.convert_points_link}</p>
                                                    <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
                                                        {translate[lang]?.active}
                                                    </div>
                                                    <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>

                            <Post_content mode={'hust_media'} show_adsense={'YES'} show_adskeeper={'NO'} uri={'p2p_social_partner'} />

                        </div>
                    </>)}
            </div>
            <br />
            <br />
            <br />
            <br />
        </div>
    );
};

export default MyComponent;